/**
 * Serviço de Cache
 * Gerencia operações relacionadas ao cache de sugestões de produção
 */

import axios from 'axios';
import { supabase } from './supabaseClient';

// Obter API URL do sistema de configuração dinâmica
const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    '/api'
  );
};

const API_URL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const cacheService = {
  /**
   * Obtém o token de autenticação do Supabase
   * @private
   */
  async getAuthToken() {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;

    if (!token) {
      throw new Error('Usuário não autenticado. Faça login para acessar o cache.');
    }

    return token;
  },

  /**
   * Obtém informações sobre o status do cache
   */
  async getCacheInfo() {
    try {
      const token = await this.getAuthToken();
      const response = await axiosInstance.get('/cache/info', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.cache;
    } catch (error) {
      console.error('Erro ao obter informações do cache:', error);
      throw error;
    }
  },

  /**
   * Força atualização do cache
   */
  async updateCache(force = true) {
    try {
      const token = await this.getAuthToken();
      const response = await axiosInstance.post('/cache/update', { force }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar cache:', error);
      throw error;
    }
  },

  /**
   * Invalida todo o cache
   */
  async invalidateCache() {
    try {
      const token = await this.getAuthToken();
      const response = await axiosInstance.post('/cache/invalidate', {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao invalidar cache:', error);
      throw error;
    }
  },

  /**
   * Limpa cache expirado
   */
  async cleanCache() {
    try {
      const token = await this.getAuthToken();
      const response = await axiosInstance.delete('/cache/clean', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao limpar cache:', error);
      throw error;
    }
  }
};
